import BuiltForCreators from "@/components/creatorshield/BuiltForCreators";
import FAQ from "@/components/creatorshield/FAQ";
import FinalCTA from "@/components/creatorshield/FinalCTA";
import Footer from "@/components/creatorshield/Footer";
import ForMediaCompanies from "@/components/creatorshield/ForMediaCompanies";
import FullFinancialControl from "@/components/creatorshield/FullFinancialControl";
import Header from "@/components/creatorshield/Header";
import HeroSection from "@/components/creatorshield/HeroSection";
import HowItWorks from "@/components/creatorshield/HowItWorks";
import Platforms from "@/components/creatorshield/Platforms";
import SimpleProcess from "@/components/creatorshield/SimpleProcess";
import SocialProof from "@/components/creatorshield/SocialProof";
import scrollTo from "@/utils/scrollTo";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function CreatorshieldMain() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollTo(location.state.scrollTo);
        window.history.replaceState({}, document.title);
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <div>
      <Header />
      <SimpleProcess />
      <HeroSection />
      <BuiltForCreators />
      <HowItWorks />
      <SocialProof />
      <FullFinancialControl />
      <ForMediaCompanies />
      <Platforms />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
